import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { SubjectService } from './subject.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  public socketStatus = false;

  constructor(
    private socket: Socket,
    public subject: SubjectService,
  ) {
    this.checkStatus();
    this.registerNetHandlers();
  }

  checkStatus() {
    this.socket.on('connect', () => {
      console.log('conectado al servidor');
      this.socketStatus = true;
      this.subject.desconexionEvento(true);
    });

    this.socket.on('disconnect', () => {
      console.log('desconectado del servidor');
      this.socketStatus = false;
      this.subject.desconexionEvento(false);
    });
  }

  emit(evento: string, payload?: any, callback?: Function) {
    this.socket.emit(evento, payload, callback);
  }

  listen(evento: string) {
    return this.socket.fromEvent(evento);
  }

  loginWS(correo: string, idAdmin, idAgente, idAdmin_canal) {
    this.socket.emit('configurarAgente',
      { correo, idAdmin, idAgente, idAdmin_canal },
      (res) => { });
  }

  cerrarSesion(correo: string, idAdmin, idAgente, idAdmin_canal) {
    this.socket.emit('cerrarSesion',
      { correo, idAdmin, idAgente, idAdmin_canal },
      (res) => { });
  }

  // ya no lo uses como booleano, mándalo completo
  private registerNetHandlers() {

    // 1) responder al ping del backend
    this.socket.on('net:ping', (notify: Function) => {
      if (notify) {
        notify(); // "sí, sigo vivo"
      }
    });

    // 2) escuchar la calidad que nos mande el back
    this.socket.on('net:quality', (data: any) => {
      // console.log('Calidad de red:', data);
      // 👇 aquí mandamos el evento tal cual al SubjectService
      this.subject.redCalidadEvento(data);
    });
  }
}
